export default __webpack_public_path__ + "media/images/main/menu-arrow-0682a973e3a89db5cb11703835a496ba.png";